<template>
  <header id="main-header">
    <div id="inner">
      <div id="logo">
        <a href="/">
          <img alt="HiLite Logo" src="@/assets/images/logo.svg" />
        </a>
      </div>
      <ul id="nav">
        <li>
          <a href="#">
            Library
          </a>
        </li>
        <li>
          <a href="#">
            Account
          </a>
        </li>
        <li>
          <a href="#">
            Help
          </a>
        </li>
      </ul>
      <Search />
      <HeaderAccount />
      <div id="mobile-menu"></div>
    </div>
  </header>
</template>

<script>
import Search from "@/components/Search";
import HeaderAccount from "@/components/HeaderAccount";

export default {
  name: "Header",
  components: {
    Search,
    HeaderAccount
  }
};
</script>

<style lang="stylus" scoped>
header
  width: 100%
  height: 90px
  box-shadow: 0px 5px 40px 10px rgba(0,0,0,0.15)
  @media only screen and (min-width: 1060px)
    overflow: hidden
  @media screen and (max-width: mobile-landscape)
    height: 80px
  &:after
    content: ''
    width: 100%
    height: 90px
    position: absolute
    z-index: -1
    left: 0px
    top: 90px
    background-image: url('../assets/images/net-texture.png')
    background-size: auto
    background-repeat: no-repeat
    background-position: center center
  #inner
    full-width-content()
    height: 100%
    margin: auto
    position: relative
    display: flex
    align-items: center
    justify-content: space-between
    @media only screen and (min-width: 1060px)
      &:after
        content: ''
        width: 100%
        height: 90px
        position: absolute
        right: -100%
        z-index: 0
        background: linear-gradient(to bottom, #f05f38 0%,#d85633 100%)
#nav
  list-style: none
  display: flex
  height: 100%
  margin: 0px 5% 0px 5%
  padding: 0px
  justify-content: center
  li
    font-family: "montserrat"
    font-weight: 600
    height: 100%
    display: flex
    justify-content: center
    margin: auto auto 0px 25px
    &:first-of-type
      margin-left: 0px
    a
      text-decoration: none
      color: inherit
      line-height: 90px
      border-bottom: 0px solid #121844;
      transition: 150ms border
    &:hover
      a
        border-bottom: 4px solid #121844;
#logo
  a, img
    height: 60px
  @media screen and (max-width: tablet)
    height: 50px
    a, img
      height: 50px
@media screen and (max-width: tablet)
  #nav, #type-search, #header-account
    display: none
#mobile-menu
  background-image: url('../assets/images/menu.svg')
  background-size: 30px auto
  background-position: right center
  background-repeat: no-repeat
  width: 60px
  height: 50px
  cursor: pointer
  display: none
  @media screen and (max-width: tablet)
    display: block
</style>
